import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faFacebook,
  faLinkedin,
  faTwitter,
  faYoutube,
  faXTwitter,
  faTiktok,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons'

import {
  faCamera,
  faCheck,
  faCogs,
  faCopy,
  faCube,
  faEnvelope,
  faExclamationTriangle,
  faHourglassStart,
  faInfoCircle,
  faLink,
  faLocationArrow,
  faMapMarker,
  faMapPin,
  faPhone,
  faSpinner,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'

import { faHandPointRight } from '@fortawesome/free-regular-svg-icons'

library.add(
  faFacebook,
  faLinkedin,
  faTwitter,
  faYoutube,
  faXTwitter,
  faTiktok,
  faInstagram,

  faCamera,
  faCheck,
  faCogs,
  faCopy,
  faCube,
  faEnvelope,
  faExclamationTriangle,
  faHourglassStart,
  faInfoCircle,
  faLink,
  faLocationArrow,
  faMapMarker,
  faMapPin,
  faPhone,
  faSpinner,
  faTimesCircle,

  faHandPointRight,
)

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('fa', FontAwesomeIcon)
})
